import { LayerProperty } from 'cadenza/map/layer-property';

export const SketchLayerProperty = Object.assign({
  IS_SAVING: 'isSaving',
  LAST_SAVED_DATE: 'lastSavedDate'
}, LayerProperty);
